import {MouseEventHandler} from "react";
import classNames from "classnames";
import {normalizePhone} from "@/shared/lib/format/normalizePhone";
import styles from "./Phone.module.scss";

type Props = {
    phone: string;
    className?: string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export const Phone = ({phone, className, onClick}: Props) => {
    if (!phone) {
        return null;
    }

    const normalizedPhone = normalizePhone(phone);

    if (!normalizedPhone) {
        return null;
    }

    return (
        <a
            href={`tel:+7${normalizedPhone}`}
            className={classNames(styles.phone, className)}
            onClick={onClick}
        >
            {phone}
        </a>
    );
};
